import { render } from "./NavBarItem.vue?vue&type=template&id=38049d68"
import script from "./NavBarItem.vue?vue&type=script&lang=js"
export * from "./NavBarItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__